export default "https://cdn-static.gokick.com/assets/3759ced803c9aed0ddbd8c13c713c33e7dde05d8/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";